<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container fluid>
            <v-alert
              value="message" v-if="message"
              type="success"
              outline
            > <span> {{ message }} </span>
            </v-alert>

             <v-alert
              value="error" v-if="error"
              type="warning"
              outline
            > <span> {{ error }} </span>
            </v-alert>

           <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Edit User</span>
              </v-card-title>
    
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                   <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field 
                       v-model="editedItem.firstName" 
                       label="First Name"
                       :rules="firstNameRules" 
                       required
                       >
                       </v-text-field>

                      <v-text-field 
                       v-model="editedItem.lastName" 
                       label="Last Name"
                       :rules="lastNameRules" 
                       required
                       >
                       </v-text-field>

                      <v-text-field 
                       v-model="editedItem.username" 
                       label="Username"
                       :rules="usernameRules" 
                       required
                       readonly
                       >
                      </v-text-field>

                      <v-select
                        :items="roleNames"
                        label="Role"
                        v-model="editedItem.role"
                        outline
                        :rules="roleRules" 
                        required
                      >
                      </v-select>

                      <v-select
                        :items="activeNames"
                        label="Active"
                        v-model="editedItem.active"
                        outline
                        required
                      >
                      </v-select>

                      <v-select
                        :items="accountStatusNames"
                        label="Account Status"
                        v-model="editedItem.accountStatus"
                        outline
                        required
                      >
                      </v-select>

                    </v-form>
                  </v-layout>
                </v-container>
              </v-card-text>
    
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click.native="close">Cancel</v-btn>
                <v-btn color="primary" @click.native="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

            <v-layout>
              <v-spacer></v-spacer>
              <v-btn v-if="canExportUsersReport" color="primary" @click="getUsersExport"> Export Users </v-btn>
            </v-layout>

            <template>
              <div>
                <table cellpadding="8" cellspacing="0">
                  <thead>
                    <tr>
                      <th>User ID</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Merchant ID</th>
                      <th>Merchant Name</th>
                      <th>Last Login Time</th>
                      <th>Trials</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in loggedInUsers" :key="item.userId">
                      <td>{{ item.userId }}</td>
                      <td>{{ item.firstName }}</td>
                      <td>{{ item.lastName }}</td>
                      <td>{{ item.merchantId }}</td>
                      <td>{{ item.merchantName }}</td>
                      <td>{{ item.lastLoginTime }}</td>
                      <td>{{ item.trials }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'viewloginhistory',
  data: function() {
    return {
      headers: [
        { text: 'User ID', value: 'userId' },
        { text: 'First Name', value: 'firstName' },
        { text: 'Last Name', value: 'lastName' },
        { text: 'Merchant ID', value: 'merchantId' },
        { text: 'Merchant Name', value: 'merchantName' },
        { text: 'Last Login Time', value: 'lastLoginTime' },
        { text: 'Trials', value: 'trials' }
      ],
      users: [],
      loggedInUsers: [],
      error: null,
      message: '',
      componentKey: 0,
      loading: true,
      pagination: {},
      totalUsers: 0,
      dialog: false,
      editedIndex: -1,
      defaultItem: {
        firstName: '',
        lastName: '',
        username: '',
        role: ''
      },
      editedItem: {
        id: '',
        firstName: '',
        lastName: '',
        username: '',
        role: ''
      },
      roles: [],
      roleNames: [],
      valid: true,
      firstNameRules: [
        v => !!v || 'First Name is required'
      ],
      lastNameRules: [
        v => !!v || 'Last Name is required'
      ],
      usernameRules: [
        v => !!v || 'Username is required'
      ],
      roleRules: [
        v => !!v || 'Role is required'
      ],
      canEditUser: false,
      canExportUsersReport: false,
      accountStatusNames: ['LOCKED', 'NOT LOCKED'],
      activeNames: ['ACTIVE', 'NOT ACTIVE']
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
            // this.users = data.items
            // this.totalUsers = data.total
          })
      },
      deep: true
    }
  },
  mounted () {
    this.getDataFromApi()
      .then(data => {
        // this.users = data.items
        // this.totalUsers = data.total
      })
    this.getLoggedInUsers()
    this.getRoles()
    this.canEditUser = this.canEditUsers()
    this.canExportUsersReport = this.canExportUsers()
  },
  methods: {
    async getDataFromApi () {
      this.loading = true

      const { sortBy, descending, page, rowsPerPage } = this.pagination

      try {
        let items = await this.getLoggedInUsers()
        const total = items.length

        if (sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              return sortA < sortB ? 1 : sortA > sortB ? -1 : 0
            } else {
              return sortA < sortB ? -1 : sortA > sortB ? 1 : 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loggedInUsers = items
          this.totalUsers = total
          this.loading = false
        }, 1000)
      } catch (e) {
        this.loading = false
        console.log('Error loading data', e)
      }
    },
    editItem (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    canEditUsers() {
      return store.state.user.permissions.includes('CAN_UPDATE_INTERNALUSERS')
    },
    canExportUsers() {
      return store.state.user.permissions.includes('CAN_EXPORT_INTERNAL_USERS')
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.saveUser()
        }
        this.close()
      }
    },
    async deleteItem(item) {
      try {
        var token = store.state.token;
        const response = await fetch(config.serverURI + `/user/internaluser/delete/${item.id}`, {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });
        // if (!response.ok) {
        //   throw new Error(`Failed to delete User with id: ${item.id}`);
        // }
        this.items = this.items.filter(i => i.id !== item.id);
        alert(`Item "${item.name}" deleted successfully!`);
        this.componentKey += 1;
      } catch (error) {
        console.error("Error deleting item:", error);
        this.items = this.items.filter(i => i.id !== item.id);
        alert(`Item "${item.name}" deleted successfully!`);
        this.componentKey += 1;
      }
    },
    saveUser() {
      var url = config.serverURI + '/user/internaluser/update'
      var token = store.state.token
      axios.post(url, this.editedItem, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('Update Response:', response)
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }

            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    },
    async getLoggedInUsers() {
      const url = config.serverURI + '/user/login-info'
      const token = store.state.token

      try {
        const response = await axios.get(url, {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        })

        if (response.status !== 200) {
          this.error = response.statusText
          console.error('Error:', this.error)
          return
        }

        this.loggedInUsers = response.data
      } catch (error) {
        console.log(error)
      }
    },
    getRoles () {
      var url = config.serverURI + '/admin/role/getAll'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.roles = response.data
            const mapFunction = p => p.name
            this.roleNames = this.roles.map(mapFunction)
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    },
    getUsersExport () {
      let url = config.serverURI + '/user/internaluser/extract'
      let token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        },
        responseType: 'blob'
      })
          .then(response => {
            console.log('API Response:', response)
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            var now = new Date()
            var fileName = 'usersexport_' + now + '.xls'
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// viewuserloginhistory.vue?3e8be8f7